export default "__VITE_ASSET__D$q3nR6n__"